<div class="upload-parameters-box" [ngClass]="{'animate': (uploadStatus$ | async) === 'Starting' || (updateAndResumeUploadLoading$ | async) }">

    <div class="upload-parameters-box-header">
        <div class="tabs">
            <ng-container *ngIf="dropbox ; else uploaderTabs">
                <div class="tab">
                    <div class="tab-title" translate>UPLOADER_PARAMETERS_NEW_TRANSFER</div>
                </div>
            </ng-container>
            <ng-template #uploaderTabs>
                <ng-container *ngIf="transferSettings?.delivery?.options?.length > 1; else noTabDisplayed">
                    <button class="tab" [ngClass]="{'tab-selected': (uploadFormMode) === tab}" *ngFor="let tab of transferSettings.delivery.options"
                        (click)="onSelectSmashMode(tab)">{{tabTranslate[tab]| translate }}</button>
                </ng-container>
                <ng-template #noTabDisplayed>
                    <div class="tab">
                        <div class="tab-title" translate>UPLOADER_PARAMETERS_NEW_TRANSFER</div>
                    </div>
                </ng-template>
            </ng-template>
        </div>
    </div>
    <div class="upload-parameters-box-content">
        <ng-container *ngIf="dropbox; else uploaderForm">
            <app-email-form #emailForm
                class="email-form"
                [dropbox]="dropbox"
                [identity]="identity$ | async" 
                (emailFormSubmitted)="handleFormSubmitted($event)">
            </app-email-form>
        </ng-container>
        <ng-template #uploaderForm>
            <ng-container *ngIf="(uploadFormMode) === 'Email'; else second">
                <app-email-form  #emailForm
                    class="email-form"
                    [identity]="identity$ | async" 
                    (emailFormSubmitted)="handleFormSubmitted($event)">
                </app-email-form>
            </ng-container>
            <ng-template #second>
                <ng-container *ngIf="(uploadFormMode) === 'Link'">
                    <app-link-form #linkForm [identity]="identity$ | async" [domain]="domain$ | async" 
                        [transferSettings]="transferSettings"
                        (linkFormSubmitted)="handleFormSubmitted($event)">
                    </app-link-form>
                </ng-container>
            </ng-template>
        </ng-template>
        <div class="config-drawer" [ngClass]="{'visible': (drawerExpanded$ | async) === true }">
            <div class="config-drawer-container" [ngClass]="{'visible': (drawerExpanded$ | async) === true}">
                <app-config-send-parameters 
                    [uploadFormMode]="uploadFormMode" 
                    [drawerExpanded]="drawerExpanded$ | async" 
                    [transferSettings]="transferSettings"
                    [transferCommonParameters]="transferCommonParameters$ | async"
                    [promotions]="promotions"
                    [promotionLoading]="promotionLoading"
                    [promotionSelected]="promotionSelected" 
                    [customizationSelected]="customization"
                    [customizationLoading]="customizationLoading">
                </app-config-send-parameters>
            </div>
        </div>
        <div class="email-validation" *ngIf="(verificationCodeFormDisplayed$ | async)">
            <div class="email-validation-container">
                <app-email-validation #emailValidation></app-email-validation>
            </div>
        </div>
    </div>

    <div class="upload-parameters-box-footer">
        <div class="upload-parameters-box-footer-left">
            <div class="upload-parameters-box-footer-icon-container" *ngIf="canConfigSmash">
                <ng-container *ngIf="(verificationCodeFormDisplayed$ | async)">
                    <i class="icon-smash_arrow_navigation validation-code-button-back" (click)="handleCloseVerificationCode()"></i>
                </ng-container>
                <ng-container *ngIf="(drawerExpanded$ | async) && !(verificationCodeFormDisplayed$ | async) && !(verifyEmailLoading$ | async)">
                    <i class="icon-smash_close" (click)="handleOpenCloseDrawer()"></i>
                </ng-container>
                <ng-container *ngIf="(uploadStatus$ | async) !== 'Starting' && !(drawerExpanded$ | async) && !(verificationCodeFormDisplayed$ | async) && !(verifyEmailLoading$ | async)">
                    <i class="icon-smash_settings" (click)="handleOpenCloseDrawer()"></i>
                </ng-container>
            </div>
            <div class="upload-parameters-box-footer-main-informations-container"
                *ngIf="(uploadStatus$ | async) !== 'Starting' && !(drawerExpanded$ | async) && !(verificationCodeFormDisplayed$ | async) && !(verifyEmailLoading$ | async)"
                (click)="handleOpenCloseDrawer()">
                <div class="info-expiration-date" translate [translateParams]="{'date': translatedAvailabilityDuration}">UPLOADER_EXPIRE_ON</div>
                <div class="info-password">
                    <ng-container *ngIf="!!(transferPassword$ | async); else noPassword">
                        {{ 'UPLOADER_PASSWORD_ADDED' | translate }}
                    </ng-container>
                    <ng-template #noPassword>
                        {{ 'UPLOADER_NO_PASSWORD' | translate }}
                    </ng-template>
                </div>
            </div>
        </div>
        <div class="upload-parameters-box-footer-right">
            <ng-container *ngIf="(drawerExpanded$ | async)">
                <button type="button" class="btn red" (click)="handleOpenCloseDrawer()">{{
                    'UPLOADER_CONFIG_SMASH_BUTTON_LABEL_DONE' | translate
                    }}</button>
            </ng-container>
            <ng-container *ngIf="(verificationCodeFormDisplayed$ | async)">
                <button [disabled]="(validateEmailVerificationCodeLoading$ | async) || (sendEmailVerificationLoading$ | async)" type="button"
                    class="btn red" (click)="submitVerificationCode()">
                    <div class="loading-spinner-white spinner-button"
                        *ngIf="(validateEmailVerificationCodeLoading$ | async) || (sendEmailVerificationLoading$ | async)">
                    </div>
                    <div *ngIf="!(validateEmailVerificationCodeLoading$ | async) && !(sendEmailVerificationLoading$ | async)">
                        {{
                        'UPLOADER_EMAIL_VALIDATION_BUTTON_VERIFY' | translate}}</div>
                </button>
            </ng-container>
            <ng-container *ngIf="!(drawerExpanded$ | async) && !(verificationCodeFormDisplayed$ | async) && uploadFormMode === 'Email'">
                <button
                    [disabled]="(uploadStatus$ | async) === 'Starting' || (updateAndResumeUploadLoading$ | async) || (verifyEmailLoading$ | async)"
                    id="button-send-transfer-email" type="submit" class="btn red animated" (throttledClick)="submitForm(); false"
                    appPreventDoubleClick>
                    <div class="loading-spinner-white spinner-button"
                        *ngIf=" (uploadStatus$ | async) === 'Starting' || (verifyEmailLoading$ | async) || (updateAndResumeUploadLoading$ | async)">
                    </div>
                    <div *ngIf="(uploadStatus$ | async) !== 'Starting' && !(updateAndResumeUploadLoading$ | async) &&  !(verifyEmailLoading$ | async)">
                        {{ 'UPLOADER_EMAIL_FORM_SMASH' | translate}}</div>
                </button>
            </ng-container>
            <ng-container *ngIf="!(drawerExpanded$ | async) && !(verificationCodeFormDisplayed$ | async) && uploadFormMode === 'Link'">
                <button
                    [disabled]="(uploadStatus$ | async) === 'Starting' || (verifyEmailLoading$ | async) || (updateAndResumeUploadLoading$ | async)"
                    id="button-send-transfer-link" type="submit" class="btn red animated" (throttledClick)="submitForm(); false"
                    appPreventDoubleClick>
                    <div class=" loading-spinner-white spinner-button"
                        *ngIf=" (uploadStatus$ | async) === 'Starting' || (verifyEmailLoading$ | async) || (updateAndResumeUploadLoading$ | async)">
                    </div>
                    <div *ngIf="(uploadStatus$ | async) !== 'Starting' && !(updateAndResumeUploadLoading$ | async) && !(verifyEmailLoading$ | async)">
                        {{'UPLOADER_LINK_FORM_BUTTON_LABEL_OBTAIN' |translate}}
                    </div>
                </button>
            </ng-container>
        </div>
    </div>
</div>